import React, { useEffect, useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";

import { getOnboardingDetails, onboardingQuestions, setDataForStates, setOnboardingData, generateUserFinancialGoal } from "../../shared/_services/common.services";
import Loader from "../Loader";
import AIChatBot from "./AIChatBot";

function getFirstOnboardingRecordOrEmpty(detailsResponse) {
  if (Array.isArray(detailsResponse?.data?.data)) {
    return detailsResponse.data.data[0];
  }
  if (detailsResponse?.data?.error) {
    return [];
  }
  return null;
}

const QuestionSeven = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const [financialAdvisorExperience, setFinancialAdvisorExperience] = useState("");
  const [importantFinancialDecision, setImportantFinancialDecision] = useState("");
  const [aboutYourself, setAboutYourself] = useState("");
  const [nonFinancialConcerns, setNonFinancialConcerns] = useState("");
  const [thingsToDiscuss, setThingsToDiscuss] = useState("");
  const [currentQuestion, setCurrentQuestion] = useState([]);
  const isFromUserQuestionnaire = location?.state?.fromUserQuestionnaire;
  const [showLoaderNine, setShowLoaderNine] = useState(false);
  const quickSetup = JSON.parse(localStorage.getItem("currentUser"))?.user?.quickSetup;

  const checkAndFillDataForQuesNine = async () => {
    setShowLoaderNine(true);
    try {
      const questions = await onboardingQuestions("Let’s help your advisor understand your world.");
      // #69: same crash class as QuestionSix — an API failure leaves `.data`
      // undefined, a malformed 200 body can leave it non-array-but-truthy,
      // and currentQuestion[0] is read unguarded elsewhere in this screen.
      setCurrentQuestion(Array.isArray(questions?.data) ? questions.data : []);

      if (questions.status !== 200) {
        return;
      }

      const getOnboardingDetailsData = await getOnboardingDetails(questions?.data[0]?._id);
      if (getOnboardingDetailsData.status !== 200) {
        return;
      }

      const onboardingData = getFirstOnboardingRecordOrEmpty(getOnboardingDetailsData);
      const temp = setDataForStates(questions.data[0], onboardingData, true);

      if (temp.selectedData.length === 0) {
        return;
      }

      const fieldSetters = [
        setFinancialAdvisorExperience,
        setImportantFinancialDecision,
        setAboutYourself,
        setNonFinancialConcerns,
      ];

      temp.selectedData.forEach((data, index) => {
        const setter = fieldSetters[index] ?? setThingsToDiscuss;
        setter(data.value);
      });
    } finally {
      setShowLoaderNine(false);
    }
  };

  useEffect(() => {
    checkAndFillDataForQuesNine();
  }, [])

  const handleNextQuestion = async (actionType) => {
    setShowLoaderNine(true);
    const body = createRequestBody();

    // If all fields are empty
    const areAllFieldsEmpty =
      !financialAdvisorExperience &&
      !importantFinancialDecision &&
      !aboutYourself &&
      !nonFinancialConcerns &&
      !thingsToDiscuss;

    if (areAllFieldsEmpty) {
      setShowLoaderNine(false);

      // If user came from the questionnaire, navigate back to it
      if (isFromUserQuestionnaire) {
        navigate('/questionnaire');
        return;
      }

      // Otherwise, show the skip modal or navigate to dashboard
      navigateToNextStep(actionType);
      return;
    }

    try {
      // Proceed with saving data if at least one field is filled
      const onboardingResponse = await setOnboardingData(body);

      if (onboardingResponse?.status === 201) {
        const goalResponse = await generateUserFinancialGoal();

        if (!(goalResponse?.goals?.length >= 0 || goalResponse)) {
          console.error("Failed to generate user financial goals:", goalResponse);
        }
        setShowLoaderNine(false);
        navigateToNextStep(actionType);
      } else {
        setShowLoaderNine(false);
        console.error("Failed to save onboarding data:", onboardingResponse);
        // Navigate even if save fails
        navigateToNextStep(actionType);
      }
    } catch (error) {
      setShowLoaderNine(false);
      console.error("Error in handleNextQuestion:", error);
      // Navigate even if there's an error
      navigateToNextStep(actionType);
    }
  };

  // Helper function to navigate based on the flow
  const navigateToNextStep = (actionType) => {
    if (isFromUserQuestionnaire) {
      navigate('/questionnaire');
    } else {
      navigate('/dashboard', {
        state: { actionType }
      });
    }
  };





  // Helper function to create the request body
  const createRequestBody = () => {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    const temp = [
      { name: "Have you worked with a financial advisor before?", value: financialAdvisorExperience },
      { name: "When you’re making financial decisions, what do you usually rely on?", value: importantFinancialDecision || "" },
      { name: "Tell us about your life (family, job, hobbies).", value: aboutYourself || "" },
      { name: "Anything important (non-financial) going on? (Stress, big life changes, caregiving, career shifts, etc.)", value: nonFinancialConcerns || "" },
      { name: "What would you like to talk about first with your advisor?", value: thingsToDiscuss || "" },
    ];

    return {
      clientId: currentUser?.user?._id,
      questionId: currentQuestion[0]?._id,
      selectedOptions: temp,
    };
  };




  return (
    <>
      {showLoaderNine ? (
        <Loader />
      ) : (
        <div className="question-set">
          <div className="onboaring-quesn justify-content-between d-flex place-items-center">
            <h2>
              {quickSetup === true ? <></> : <span>Q7</span>}
              <div>
                Let’s help your advisor understand your world.
                <br />
                <p>Share as much or as little as you want — this helps your advisor personalize your plan.</p>
              </div>
            </h2>
            {!isFromUserQuestionnaire && (
              <button
                type="button"
                className="as-btn-secondary"
                onClick={() => { navigate('/dashboard') }}
              >
                Continue Later</button>)}
          </div>

          <div className="d-flex mb-2">
            <div className="onboarding-label mr-4 f-600">
              Have you worked with a financial advisor before?
            </div>
            {/* <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="financialAdvisorExperience"
                id="financialAdvisorYes"
                checked={financialAdvisorExperience === 'Yes'}
                value="Yes"
                onChange={(e) => setFinancialAdvisorExperience(e.target.value)}
              />
              <label className="form-check-label" htmlFor="financialAdvisorYes">
                Yes
              </label>
            </div>
            <div className="form-check form-check-inline">
              <input
                className="form-check-input"
                type="radio"
                name="financialAdvisorExperience"
                id="financialAdvisorNo"
                checked={financialAdvisorExperience !== 'Yes'}
                value="No"
                onChange={(e) => setFinancialAdvisorExperience(e.target.value)}
              />
              <label className="form-check-label" htmlFor="financialAdvisorNo">
                No
              </label>
            </div> */}
            <div className="d-flex align-items-center">
              <span className="mr-2">No</span>

              <div className="custom-control custom-switch">
                <input
                  type="checkbox"
                  className="custom-control-input"
                  id="financialAdvisorSwitch"
                  checked={financialAdvisorExperience === "Yes"}
                  onChange={(e) =>
                    setFinancialAdvisorExperience(e.target.checked ? "Yes" : "No")
                  }
                />
                <label className="custom-control-label" htmlFor="financialAdvisorSwitch"></label>
              </div>

              <span className="ml-2">Yes</span>
            </div>
          </div>

          <div className="my-4" style={{ borderBottom: "2px dashed #D9D9D9" }}>
          </div>


          <div className="form-group">
            <label className="onboarding-label f-600" htmlFor="Important_financial_decision">
              1. When you’re making financial decisions, what do you usually rely on?
            </label>
            {/* <input
              type="text"
              className="form-control onb-input"
              id="Important_financial_decision"
              value={importantFinancialDecision}
              onChange={(e) => setImportantFinancialDecision(e.target.value)}
            /> */}
            <div className="common-other-textbox">
              <textarea
                id="Important_financial_decision"
                value={importantFinancialDecision}
                onChange={(e) => setImportantFinancialDecision(e.target.value)}
                placeholder="Online research, partner, podcasts, gut instinct…"
              ></textarea>
            </div>
          </div>

          <div className="form-group">
            <label className="onboarding-label f-600" htmlFor="about_yourself">
              2. Tell us about your life (family, job, hobbies).
            </label>
            {/* <input
              type="text"
              className="form-control onb-input"
              id="about_yourself"
              value={aboutYourself}
              onChange={(e) => setAboutYourself(e.target.value)}
            /> */}
            <div className="common-other-textbox">
              <textarea
                id="about_yourself"
                value={aboutYourself}
                onChange={(e) => setAboutYourself(e.target.value)}
                placeholder="Anything that shapes your priorities."
              ></textarea>
            </div>
          </div>

          <div className="form-group">
            <label className="onboarding-label f-600" htmlFor="Non_Financial_concerns">
              3. Anything important (non-financial) going on? (Stress, big life changes, caregiving, career shifts, etc.)
            </label>
            {/* <input
              type="text"
              className="form-control onb-input"
              id="Non_Financial_concerns"
              value={nonFinancialConcerns}
              onChange={(e) => setNonFinancialConcerns(e.target.value)}
            /> */}
            <div className="common-other-textbox">
              <textarea
                id="Non_Financial_concerns"
                value={nonFinancialConcerns}
                onChange={(e) => setNonFinancialConcerns(e.target.value)}
                placeholder="Share anything you want your advisor to keep in mind."
              ></textarea>
            </div>
          </div>

          <div className="form-group">
            <label className="onboarding-label f-600" htmlFor="things_to_dscuss">
              4. What would you like to talk about first with your advisor?
            </label>
            {/* <input
              type="text"
              className="form-control onb-input"
              id="things_to_dscuss"
              value={thingsToDiscuss}
              onChange={(e) => setThingsToDiscuss(e.target.value)}
            /> */}
            <div className="common-other-textbox">
              <textarea
                id="things_to_dscuss"
                value={thingsToDiscuss}
                onChange={(e) => setThingsToDiscuss(e.target.value)}
                placeholder="Investing, debt, retirement, buying a home…"
              ></textarea>
            </div>
          </div>
        </div>)}
      {!showLoaderNine && (
        <div className="onboarding-footer">
          <div className="onboarding-footer-btns">
            <div className="d-flex justify-content-between w-100">
              {isFromUserQuestionnaire ? (
                <>
                  <button
                    type="button"
                    className="as-btn-secondary"
                    onClick={() => {
                      navigate("/questionnaire")
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="as-btn-primary"
                    onClick={handleNextQuestion}
                  >
                    Update
                  </button>
                </>
              ) : (
                <>
                  {quickSetup === true ?
                    <button
                      type="button"
                      className="as-btn-secondary"
                      onClick={() => navigate("/q1")}
                    >
                      ← Priority
                    </button>
                    :
                    <button
                      type="button"
                      className="as-btn-secondary"
                      onClick={() => navigate("/q6")}
                    >
                      ← Money Snapshot (Investments)
                    </button>
                  }

                  <div className="d-flex gap-10">
                    <button
                      type="button"
                      className="as-btn-primary"
                      onClick={() => handleNextQuestion("MESSAGE")}
                    >
                      Send a Message to Your Advisor →
                    </button>
                    <button
                      type="button"
                      className="as-btn-primary"
                      onClick={() => handleNextQuestion("VIDEO_CALL")}
                    >
                      Book a Video Call Instead
                    </button>
                  </div>

                </>
              )}
            </div>
            <AIChatBot
              questionName={currentQuestion[0]?.questionName}
              options={[
                "How do you make Important financial decision now?",
                "Tell me about yourself. (family, hobbies, job, etc)",
                "What your most important Non-Financial concerns?",
                "What things would you like to discuss with your advisor on your scheduled appt?"
              ]}
              firstMsg="I’m here to help you prepare for working with a financial advisor. What questions or concerns do you have about professional financial guidance?"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default QuestionSeven;